export const EFSTA_ID = 'EFSTA_Fiscal_integration';
export const EFSTA_INFO =
  'POS Fiscal integration for EFSTA. EFTSA serves as middleware to fulfil country specific fiscal requirements for POS systems using a unified interface';
